import {Component, model} from '@angular/core';
import {SearchComponent} from "./search/search.component";
import {UploadComponent} from "./upload/upload.component";
import {SearchResultComponent} from "./search-result/search-result.component";
import {ChangeLoginComponent} from "./change-login/change-login.component";
import {NgIf} from "@angular/common";
import {PromoCodeComponent} from "./promocode/promo-codes.component";
import {PinholeUser} from "./services/pinhole.user.service";

@Component({
    selector: 'app-pinhole',
    templateUrl: './pinhole.component.html',
    imports: [
        SearchComponent,
        UploadComponent,
        SearchResultComponent,
        ChangeLoginComponent,
        NgIf,
        PromoCodeComponent
    ],
    styleUrls: ['./pinhole.component.css']
})
export class PinholeComponent {
    selectedTab = Tab.User;
    readonly user = model<PinholeUser | null>(null);

    selectTab(tab: Tab): void {
        this.selectedTab = tab;
    }

    protected readonly Tab = Tab;
}

export enum Tab {
    User, RoundUploader, PromoCodes
}
